export const uploadScannedImageData = `
  mutation UploadScannedPhoto ( $input: UploadScannedPhotoInput!) {
    uploadScannedPhoto(input: $input) {
      uploadedPhotoUrl
    }
  }
`
